import { Observable } from 'rxjs';

import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { AppEnvironment, EnvironmentInjectionToken } from '@mitsubishi/shared/data-access';

@Injectable({
  providedIn: 'root',
})
export class ProjectListGuard {
  constructor(
    @Inject(EnvironmentInjectionToken) private environment: AppEnvironment,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.environment.disableProjectList) {
      return this.router.createUrlTree(['/']);
    }
    return true;
  }
}
